import { library } from "@fortawesome/fontawesome-svg-core";
import * as solid from "./fa-solid";
import * as brands from "./fa-brands";

library.add(...Object.values(solid), ...Object.values(brands));
